/* eslint-disable no-throw-literal */

export enum ENV_VARS {
  AG_GRID_KEY = 'AG_GRID_KEY',
  CS_API_BASE_URL = 'CS_API_BASE_URL',
  CS_NOTIFICATIONS_BASE_URL = 'CS_NOTIFICATIONS_BASE_URL',
  HARNESS_KEY = 'HARNESS_KEY',
}
export function getEnv(key: ENV_VARS): any {
  // `globalThis`'s static type has no index signature, so it can't be indexed with an
  // arbitrary string (our ENV_VARS keys). These env vars are injected dynamically at
  // runtime (e.g. by the server into index.html) and aren't part of its type declarations,
  // so we cast through `unknown` to a plain string-indexable shape to read them safely.
  const globalScope = globalThis as unknown as Record<string, unknown>;
  if (!(key in globalScope) || globalScope[key] === undefined) {
    throw new Error(`Env var not defined ${key}`);
  }
  const value = globalScope[key];
  if (typeof value === 'string' && value === '') {
    throw new Error(`Env var is defined ${key} with value ''`);
  }

  return value;
}

export function getEnvOrDefault(key: ENV_VARS, defaultVal: any): any {
  try {
    return getEnv(key);
    // eslint-disable-next-line sonarjs/no-ignored-exceptions
  } catch (_error) {
    return defaultVal;
  }
}
